import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhatsAppButton() {
  const whatsappUrl = 'https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno';
  return <motion.a href={whatsappUrl} target="_blank" rel="noopener noreferrer" aria-label="Reservar sesión VIP por WhatsApp" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-16 h-16 bg-gold text-ink rounded-full shadow-[0_8px_24px_rgba(21,32,46,0.22)] hover:bg-gold-deep hover:text-white transition-colors duration-200" initial={{
    scale: 0.96,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 0.8,
    duration: 0.25,
    ease: [0.23, 1, 0.32, 1]
  }} whileHover={{
    scale: 1.06
  }} whileTap={{
    scale: 0.94
  }} data-id="element-134" data-mp="275ap0v7p97ub">
      <motion.span aria-hidden="true" animate={{
      boxShadow: ['0 0 0 0 rgba(201, 162, 39, 0.55)', '0 0 0 18px rgba(201, 162, 39, 0)']
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute inset-0 rounded-full" data-id="element-135" data-mp="8cljyqwf9t93" />
      <MessageCircle size={30} className="relative z-10" data-id="element-136" data-mp="mbl53okq7q0i" />
    </motion.a>;
}